/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'
import { Heading, Box } from '@theme-ui/components'
import { Container } from '../organisms'
import { useBreakpointIndex } from '@theme-ui/match-media';

import solar from './solar.svg'
import solar1 from './solar1.svg'
import solar2 from './solar2.svg'
import solar3 from './solar3.svg'
import solar6 from './solar6.svg';
import solar7 from './solar7.svg';
import solar8 from './solar8.svg';
import luna1 from './luna1.svg'
import luna2 from './luna2.svg'
import luna2a from './luna2a.svg'
import sol1 from './sol1.svg'
import sol2 from './sol2.svg'
import deimos1l from './deimos1l.svg'
import deimos1r from './deimos1r.svg'
import deimos2l from './deimos2l.svg'
import deimos2r from './deimos2r.svg'
import deimos3l from './deimos3l.svg'
import deimos3r from './deimos3r.svg'
import deimos4l from './deimos4l.svg'
import deimos4r from './deimos4r.svg'
import deimos5l from './deimos5l.svg'
import deimos5r from './deimos5r.svg'
import ariel1l from './ariel1l.svg'
import ariel1r from './ariel1r.svg'
import ascend from './ascend.svg'
import sirens from './sirens.svg'
import space from './space.svg'
import radial from './radial.svg'
import dioneL from './dioneL.svg'
import dioneR from './dioneR.svg'
import elaraL from './elaraL.svg'
import elaraR from './elaraR.svg'
import phobosL from './phobosL.svg'
import phobosR from './phobosR.svg'
import phobos1 from './phobos1.svg'
import phobos2L from './phobos2L.svg'
import phobos2R from './phobos2R.svg'
import callisto1L from './callisto1L.svg'
import callisto2L from './callisto2L.svg'
import callisto1R from './callisto1R.svg'
import callisto2R from './callisto2R.svg'
import callisto3 from './callisto3.svg'
import callisto4 from './callisto4.svg'
import risingSun from './risingSun.svg'
import greyPointerBox from './greyPointerBox.svg'
import greyPointerBoxM from './greyPointerBoxM.svg'
import {
	solar5,
	solar5M,
	pastelPink5,
	twainPastel7,
	twainPastel8,
	triadPastels,
	pastelBlue6,
	pastelPink6,
} from './psp';

import {
	greyOrange,
	pastelBlue7,
	pastelBlue8,
	pastelPink7,
	pastelPink8,
	twainPastel11,
	twainPastel12,
} from './gartner';

import * as payrollModuleBgs from './payroll-module';
import * as attendanceModuleBgs from './attendance-module';
import * as hrmsModuleBgs from './hrms-module';
import * as academyBGs from './academy';
import * as zohoPeopleBgs from './zoho-people';
import * as greytFMBgs from './greytFM-podcast';
import * as startupHrToolkitBgs from './startupHr-toolkit';
import * as trialSignupBgs from './trial-signup';

const SvgBackground = ({ children, bg, bgColor = "#FFF", border }) => {
  const bpIndex = useBreakpointIndex({ defaultIndex: 1 });

    const bgInfo = {
			space: {
				image: space,
				position: 'center center',
			},
			moon: {
				image: greyOrange,
				position: 'center top',
			},
			solar: {
				image: solar,
				position: '100% top',
			},
			solar1: {
				image: solar1,
				postion: '100% top',
			},
			solar2: {
				image: solar2,
				position: '0 top',
			},
			solar3: {
				image: solar3,
				position: '100% bottom',
			},
			solar4: {
				image: academyBGs.solar4,
				position: '100% top',
			},
			solar5: {
				image: bpIndex < 3 ? solar5M : solar5,
				position: '100% top',
			},
			solar6: {
				image: solar6,
				postion: '100% top',
			},
			solar7: {
				image: solar7,
				postion: '100% top',
			},
			solar8: {
				image: solar8,
				position: '100% top',
			},
			solar9: {
				image: startupHrToolkitBgs.banner,
				postion: '100% top'
			},
			solar10: {
				image: academyBGs.solar9,
				position: '100% bottom',
			},
			solarGrey: {
				image: solar3,
				position: '0 top',
				right: bpIndex < 3 ? greyPointerBoxM : greyPointerBox,
				rightPosition: bpIndex < 3 ? '50% bottom' : '100% center',
			},
			pastelPink1: {
				image: payrollModuleBgs.pastelPink4,
				position: '0% top',
			},
			twainPastel1: {
				image: academyBGs.twainPastel1,
				position: '0 center',
			},
			twainPastel2: {
				image: academyBGs.pastelPink1,
				right: bpIndex < 1 ? null : academyBGs.pastelBlue1,
				position: '0 center',
				rightPosition: '100% top',
			},
			twainPastel3: {
				image: bpIndex < 1 ? null : academyBGs.pastelPink2,
				right: academyBGs.pastelBlue2,
				position: '0 center',
				rightPosition: '100% top',
			},
			twainPastel4: {
				image: bpIndex < 1 ? null : academyBGs.pastelBlue3,
				right: bpIndex < 1 ? null : academyBGs.pastelPink3,
				position: '100% center',
				rightPosition: 'center top',
			},
			pastelBlue: {
				image: bpIndex < 1 ? null : academyBGs.pastelBlue4,
				position: '0 center',
			},
			twainPastel5: {
				image: bpIndex < 1 ? null : academyBGs.pastelBlue5,
				right: bpIndex < 1 ? null : academyBGs.pastelPink4,
				position: 'center bottom',
				rightPosition: 'center top',
			},
			twainPastel6: {
				image: academyBGs.pastelBlue4,
				right: pastelPink5,
				position: 'center bottom',
				rightPosition: 'center top',
			},
			twainPastel7: {
				image: twainPastel7,
				position: 'center bottom',
			},
			twainPastel8: {
				image: twainPastel8,
				position: 'center bottom',
			},
			triadPastels: {
				image: triadPastels,
				position: 'center bottom',
			},
			twainPastel9: {
				image: pastelPink6,
				right: bpIndex < 1 ? null : pastelBlue6,
				position: '0% top',
				rightPosition: '100% center',
			},
			twainPastel10: {
				image: pastelBlue7,
				right: pastelPink7,
				position: '0% center',
				rightPosition: '100% top',
			},
			twainPastel11: {
				image: twainPastel11,
				position: 'center top',
			},
			twainPastel12: {
				image: twainPastel12,
				position: 'center top',
			},
			twainPastel13: {
				image: pastelBlue8,
				right: pastelPink8,
				position: '0% bottom',
				rightPosition: '100% top',
			},
			twainPastel14: {
				image: payrollModuleBgs.pastelBlue,
				right: payrollModuleBgs.pastelPink,
				position: '0% center',
				rightPosition: '100% top',
			},
			twainPastel15: {
				image: payrollModuleBgs.pastelBlue1,
				right: payrollModuleBgs.pastelPink1,
				position: '0% center',
				rightPosition: '100% top',
			},
			twainPastel16: {
				image: payrollModuleBgs.pastelPink2,
				right: payrollModuleBgs.pastelBlue2,
				position: '100% center',
				rightPosition: '0% center',
			},
			twainPastel17: {
				image: payrollModuleBgs.pastelBlue3,
				right: bpIndex < 1 ? payrollModuleBgs.pastelPink3 : null,
				position: '100% bottom',
				rightPosition: '0% top'
			},
			twainPastel19: {
				image: attendanceModuleBgs.pastelBlue2,
				right: attendanceModuleBgs.pastelPink2,
				position: '0% top',
				rightPosition: '100% center',
			},
			twainPastel20: {
				image: attendanceModuleBgs.pastelPink3,
				right: attendanceModuleBgs.pastelBlue3,
				position: '0% top',
				rightPosition: '100% center',
			},
			twainPastel21: {
				image: hrmsModuleBgs.pastelBlue1,
				right: hrmsModuleBgs.pastelPink1,
				position: '0% top',
				rightPosition: '100% bottom',
			},
			twainPastel22: {
				image: hrmsModuleBgs.pastelBlue2,
				right: hrmsModuleBgs.pastelPink2,
				position: '0% top',
				rightPosition: '100% bottom',
			},
			twainPastel23: {
				image: startupHrToolkitBgs.clientsR,
				right: startupHrToolkitBgs.clientsL,
				position: '100% left',
			},
			twainPastel24: {
				image: academyBGs.pastelPink5,
				right: bpIndex < 1 ? null : academyBGs.pastelBlue1,
				position: '0 center',
				rightPosition: '100% top',
			},
			pastelOrange: {
				image: payrollModuleBgs.pastelOrange,
				position: '50% top',
			},
			pastelOrangeMb: {
				image: attendanceModuleBgs.pastelOrange,
				postion: '50% top',
			},
			pastelPink: {
				image: attendanceModuleBgs.pastelPink,
				position: '50% top',
			},
			phobos: {
				image: phobosL,
				right: phobosR,
				position: '0 100%',
				rightPosition: '100% top',
			},
			phobosDual: {
				image: phobos1,
				postion: '0 top',
			},
			phobosDual2: {
				image: phobos2L,
				right: phobos2R,
				position: '0 center',
				rightPosition: '100% top',
			},
			elara: {
				image: elaraL,
				right: elaraR,
				position: '0 top',
				rightPosition: '100% center',
			},
			twainWhites: {
				image: greytFMBgs.twainWhiteCircles,
				position: '50% top',
			},
			callisto1L: {
				image: callisto1L,
				position: '0 100%',
			},
			callisto2L: {
				image: callisto2L,
				position: '0 0',
			},
			callisto1R: {
				image: callisto1R,
				position: '100% bottom',
			},
			callisto2R: {
				image: callisto2R,
				position: '100% top',
			},
			callisto3: {
				image: callisto3,
				position: 'center bottom',
			},
			callisto4: {
				image: callisto4,
				position: 'center top',
			},
			dione: {
				image: dioneL,
				right: dioneR,
				position: '0 top',
				rightPosition: '100% bottom',
			},
			luna1: {
				image: luna1,
				position: '100% bottom',
			},
			luna2: {
				image: luna2,
				position: '100% top',
			},
			luna2a: {
				image: luna2a,
				position: '100% top',
			},
			sol1: {
				image: sol1,
				position: 'center 100%',
			},
			sol2: {
				image: sol2,
				position: 'center 0',
			},
			deimos1: {
				image: deimos1l,
				right: deimos1r,
				position: '0 100%',
				rightPosition: '100% 0',
			},
			deimos2: {
				image: deimos2l,
				right: deimos2r,
				position: '0 0',
				rightPosition: '100% 100%',
			},
			deimos3: {
				image: deimos3l,
				right: deimos3r,
				position: '0 center',
				rightPosition: '100% 100%',
			},
			deimos4: {
				image: deimos4l,
				right: deimos4r,
				position: '0 top',
				rightPosition: '100% 100%',
			},
			deimos5: {
				image: deimos5l,
				right: deimos5r,
				position: '0 top',
				rightPosition: '100% 100%',
			},
			risingSun: {
				image: risingSun,
				position: '0 bottom',
			},
			ariel1: {
				image: ariel1l,
				right: ariel1r,
				position: '0 bottom',
				rightPosition: '100% 0',
			},
			ariel2: {
				image: ariel1l,
				right: ariel1r,
				position: '0 center',
				rightPosition: '100% center',
			},
			ascend: {
				image: ascend,
				position: 'center center',
			},
			sirens: {
				image: sirens,
				position: 'center center',
			},
			radial: {
				image: radial,
				position: 'center center',
			},
			shippo: {
				image: space,
				position: 'center center',
				style: {
					backgroundColor: '#def',
					backgroundImage:
						'radial-gradient(closest-side, transparent 98%, rgba(0,0,0,.3) 99%), radial-gradient(closest-side, transparent 98%, rgba(0,0,0,.3) 99%)',
					backgroundSize: '80px 80px',
					backgroundPosition: '0 0, 40px 40px',
					backgroundRepeat: 'repeat',
				},
			},
			zohoBanner: {
				image: zohoPeopleBgs.banner,
				position: 'center top',
			},
			zohoIntro: {
				image: zohoPeopleBgs.intro,
				position: 'left bottom'
			},
			zohoPlans: {
				image: zohoPeopleBgs.plans,
				position: 'left bottom'
			},
			zohoClients: {
				image: zohoPeopleBgs.clientsL,
				right: zohoPeopleBgs.clientsR,
				position: '0 top',
				rightPosition: '100% bottom',
			},
			TrialSignupBanner: {
                image: trialSignupBgs.banner,
				postion: '100% top'
			}
		};
  
    const borderWidth = border? 1 : 0;
    const background = bgInfo[bg] || bgInfo["space"];
    const dataUri2 = `url(${background?.image})`
    // console.log(dataUri2)
  
    const leftStyle = {
      border: '0px solid red', 
      borderWidth, 
      backgroundImage: dataUri2, 
      backgroundRepeat: 'no-repeat', 
      backgroundPosition: background.position, 
      backgroundColor: bgColor,
      ...background.style,
    }
  
    const rightStyle2 = {
      border: '0px solid green',
      backgroundImage: `url(${background?.right})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: background?.rightPosition || 'center center',
    }
  
    const rightStyle = background?.right ? rightStyle2 : {};
  
    return (
      <div style={leftStyle}>
        <div style={rightStyle}>
          {children}
        </div>
      </div>
    )
  }
  
  export const SvgBackgroundTest = () => {
    return (
      <Box>
        <SvgBackground bg="luna1" bgColor="#F0F8FF">
          <Container>
            <Box sx={{ height: '600px', border: '0px solid red' }}>
              <Heading>Luna 1</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="luna2a" border={false}>
          <Container>
            <Box sx={{ height: '150px', border: '0px solid red' }}>
              <Heading>Luna 2a</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="sol1" border>
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Sol1</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="sol2">
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Sol2</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="deimos1">
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Deimos1</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="deimos2">
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Deimos2</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="ariel1" border>
          <Container>
            <Box sx={{ height: '800px', border: '0px solid red' }}>
              <Heading>Ariel1</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="ascend" border>
          <Container>
            <Box sx={{ height: '800px', border: '0px solid red' }}>
              <Heading>Ascend</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="sirens" border>
          <Container>
            <Box sx={{ height: '800px', border: '0px solid red' }}>
              <Heading>Sirens</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="shippo" bgColor="#1c90cc" border>
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Shippo</Heading>
            </Box>
          </Container>
        </SvgBackground>
        <SvgBackground bg="radial" bgColor="#1c90cc" border>
          <Container>
            <Box sx={{ height: '500px', border: '0px solid red' }}>
              <Heading>Radial1</Heading>
            </Box>
          </Container>
        </SvgBackground>
      </Box>
    )
  }
    

  export default SvgBackground;
